import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BaseURL, uniqueToken } from '../../api/DataApis';
import { Link, useParams, useLocation, useNavigate } from 'react-router-dom';
import ReactPaginate from 'react-paginate'; 
import Loader from '../Chargers/Loader';
import moment from 'moment';

const Statement = () => {
  document.title = 'Bank Accounts';

  const { user_id: userID } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [statementData, setStatementData] = useState([]);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [limit, setLimit] = useState(20);
  const [totalCount, setTotalCount] = useState(0);
  const [activeRow, setActiveRow] = useState(null);

  const fetchTransactionData = async (currentPage) => {
    setLoading(true);
    let apiEndpoint = `${BaseURL}/bank-account/${userID}?page=${currentPage}&limit=${limit}`;

    try {
      const response = await axios.get(apiEndpoint, {
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          Authorization: `Bearer ${uniqueToken}`,
        },
      });

      setStatementData(response?.data?.data || []);
      setTotalCount(response?.data?.data.length || 0);
      setPageCount(Math.ceil(response?.data?.totalCount / limit));
    } catch (error) {
      console.error('Error fetching transaction data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTransactionData(page);
  }, [page]);

  const handlePageClick = (data) => {
    setPage(data.selected + 1);
  };

  return (
    <div className='container-fluid'>
      <div className='row'>
        <div className='col-sm-12'>
          <div className='card'>
            <div className='portlet-body mx-3'>
              <div className='d-flex justify-content-between align-items-center'>
                <h4>Bank Accounts ({totalCount || 'Loading...'})</h4>
                <div className='d-flex justify-content-end'>
                  <Link
                    to={`/bank-accounts/bank-account-add/${userID}`}
                    className='btn btn-primary'
                  >
                    <i className='fa fa-plus' style={{ marginRight: '5px' }}></i> Add Bank
                  </Link>
                </div>
              </div>
              <hr style={{ marginTop: '5px' }} />

              {loading ? (
                <Loader />
              ) : (
                <div className='table-responsive'>
                  <table className="display dataTable" style={{ width: '100%', borderCollapse: 'collapse' }} id="advance-1">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Bank Name</th>
                        <th>Account Number</th>
                        <th>IFSC Code</th>
                        <th>Account Holder Name</th>
                        <th>Created At</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {statementData?.length === 0 ? (
                        <tr>
                          <td colSpan='6' className='text-center'>No Data Found</td>
                        </tr>
                      ) : (
                        statementData.map((item, index) => (
                          <tr key={index}>
                            <td>{(page - 1) * limit + index + 1}</td>
                            <td>{item?.bank_name}</td>
                            <td>{item?.account_number}</td>
                            <td>{item?.ifsc_code}</td>
                            <td>{item?.account_holder_name}</td>
                            <td>{item?.createdAt}</td>
                            <td>
                              <Link
                                to={`/bank-accounts/bank-account-edit/${userID}/${item?._id}`}
                                className="btn btn-sm btn-info"
                                title="Edit Bank Account"
                              >
                                <i className="fa fa-edit"></i> Edit
                              </Link>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>

                  <div className='pagination-container mt-4'>
                    <ReactPaginate
                      previousLabel={'Previous'}
                      nextLabel={'Next'}
                      breakLabel={'...'}
                      pageCount={pageCount}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={5}
                      onPageChange={handlePageClick}
                      containerClassName={'pagination'}
                      activeClassName={'active'}
                      forcePage={page - 1}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Statement;